export enum ObservationTypeUrlTags {
    Differentiated = 'diff',
    Formal = 'formal',
    Rubric = 'rubric',
    Walkthrough = 'wlk',
    Anecdotal = 'anecdotal',
    SLO = 'slo',
    PrincipalSLO = 'principal-slo',
    NTPE = 'ntpe',
    X82 = 'rating-form',
    CustomForm = 'custom-forms',
    SPM_IEP_PG = 'spm'
}
